import React, { useEffect, useState } from 'react';
import { Card, Button, Badge } from './ui';
import { Clock, CheckCircle, XCircle, Trophy, Star } from 'lucide-react';
type PlanKey = 'standard' | 'pro';
export function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState('pro' as PlanKey);
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 52
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const plans = [{
    key: 'standard' as PlanKey,
    icon: <span className="text-2xl leading-none" data-id="element-159">📘</span>,
    title: 'MEGAPACK FREEZER LLENO',
    includes: '6 Tomos + 6 Bonos',
    idealFor: 'Familias, parejas y personas que quieren resolver la semana completa sin improvisar',
    oldPrice: '$49.000',
    price: '$19.990',
    note: 'Precio de lanzamiento',
    noteClass: 'text-emerald-400',
    recommended: false
  }, {
    key: 'pro' as PlanKey,
    icon: <Trophy className="text-amber-400 w-6 h-6" data-id="element-160" />,
    title: 'MEGAPACK + FREEZER PRO',
    includes: '6 Tomos + 6 Bonos + Manual Avanzado',
    idealFor: 'Los que quieren dominar el sistema completo, reducir el gasto en comida un 40% y cocinar 30 porciones en 90 minutos',
    oldPrice: '$69.990',
    price: '$27.990',
    note: 'Combo completo — El mejor precio del año',
    noteClass: 'text-brand-400',
    recommended: true
  }];
  return <section className="py-12 px-4 bg-slate-950 relative" id="planes" data-id="element-161">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-900/20 via-slate-950 to-slate-950 pointer-events-none" data-id="element-162"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-163">
        <div className="text-center mb-5" data-id="element-164">
          <div className="inline-flex items-center gap-2.5 bg-red-500/15 text-red-400 border border-red-500/40 px-5 py-2.5 rounded-full font-bold mb-3 text-sm sm:text-base shadow-[0_0_20px_rgba(239,68,68,0.25)]" data-id="element-165">
            <Clock className="w-5 h-5 shrink-0 animate-pulse" data-id="element-166" />
            <span data-id="element-167">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
            <span className="tabular-nums text-white text-base sm:text-lg font-black tracking-wide" data-id="element-168">
              {String(timeLeft.h).padStart(2, '0')}:
              {String(timeLeft.m).padStart(2, '0')}:
              {String(timeLeft.s).padStart(2, '0')}
            </span>
          </div>
          <p className="text-amber-400 font-medium text-sm flex items-center justify-center gap-2" data-id="element-169">
            ⚠️ Después sube $5.000 ARS. No vuelve.
          </p>
          <div className="w-full max-w-md mx-auto mt-3 bg-slate-800 rounded-full h-1.5 overflow-hidden" data-id="element-170">
            <div className="bg-brand-500 h-full w-[72%]" data-id="element-171"></div>
          </div>
          <p className="text-[11px] text-slate-500 mt-1.5" data-id="element-172">
            72% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <h2 className="text-2xl md:text-4xl font-bold text-center text-white mb-5" data-id="element-173">
          ELEGÍ TU MEGAPACK
        </h2>

        {/* Plan selector */}
        <div className="flex flex-col gap-3 max-w-2xl mx-auto" role="radiogroup" aria-label="Elegí tu Megapack" data-id="element-174">
          {plans.map(plan => {
          const isSelected = selectedPlan === plan.key;
          return <button key={plan.key} type="button" role="radio" aria-checked={isSelected} onClick={() => setSelectedPlan(plan.key)} className={`relative w-full text-left rounded-2xl border p-4 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 focus:ring-offset-slate-950 ${isSelected ? 'border-brand-500 bg-brand-900/15 shadow-[0_0_20px_rgba(6,182,212,0.25)]' : 'border-slate-800 bg-slate-900/60 hover:border-slate-700'}`} data-id="element-175">
                {plan.recommended && <span className="absolute -top-2.5 right-4 bg-brand-500 text-white px-2.5 py-0.5 rounded-full text-[11px] font-bold flex items-center gap-1 whitespace-nowrap shadow-[0_0_12px_rgba(6,182,212,0.5)]" data-id="element-176">
                    <Star className="w-3 h-3 fill-white" data-id="element-177" /> MÁS ELEGIDO
                  </span>}

                <div className="flex items-start gap-3" data-id="element-178">
                  {/* Radio */}
                  <span className={`mt-0.5 shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-brand-400 bg-brand-500' : 'border-slate-600 bg-transparent'}`} aria-hidden="true" data-id="element-179">
                    {isSelected && <span className="w-2 h-2 rounded-full bg-white" data-id="element-180"></span>}
                  </span>

                  {/* Left content */}
                  <div className="min-w-0 flex-1" data-id="element-181">
                    <h3 className="font-bold text-white text-base flex items-center gap-2 leading-tight" data-id="element-182">
                      <span className="shrink-0" data-id="element-183">{plan.icon}</span>
                      <span className="truncate" data-id="element-184">{plan.title}</span>
                    </h3>
                    <p className="text-brand-400 text-xs font-medium mt-0.5" data-id="element-185">
                      {plan.includes}
                    </p>
                    <p className="text-slate-400 text-xs mt-1.5 leading-snug" data-id="element-186">
                      <span className="text-slate-500 font-medium" data-id="element-187">
                        Ideal para:{' '}
                      </span>
                      {plan.idealFor}
                    </p>
                    <p className={`text-[11px] font-medium mt-1.5 ${plan.noteClass}`} data-id="element-188">
                      {plan.note}
                    </p>
                  </div>

                  {/* Right price column */}
                  <div className="shrink-0 text-right pl-1" data-id="element-189">
                    <p className="text-slate-500 line-through text-xs leading-none mb-1" data-id="element-190">
                      {plan.oldPrice}
                    </p>
                    <p className="text-2xl sm:text-3xl font-black text-white leading-none" data-id="element-191">
                      {plan.price}
                    </p>
                    <p className="text-[10px] text-slate-400 mt-0.5" data-id="element-192">ARS</p>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Single main CTA */}
        <div className="max-w-2xl mx-auto mt-5" data-id="element-193">
          <Button className="w-full text-base py-4 shadow-[0_0_20px_rgba(6,182,212,0.4)]" data-id="element-194">
            {selectedPlan === 'pro' ? '→ QUIERO EL COMBO COMPLETO' : '→ QUIERO MI MEGAPACK AHORA'}
          </Button>
          <p className="text-center text-xs text-slate-500 mt-2" data-id="element-195">
            Garantía 7 días · Pago seguro · Acceso en 5 minutos
          </p>
        </div>
      </div>
    </section>;
}
export function Upsell() {
  return <section className="py-12 px-4 bg-slate-900/50 border-y border-slate-800 pt-[4px] pb-[4px]" data-id="element-196">
      <div className="max-w-4xl mx-auto" data-id="element-197">
        <div className="text-center mb-8" data-id="element-198">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-199">
            <span className="text-4xl" data-id="element-200"></span> ¿QUÉ AGREGA EL MANUAL FREEZER
            PRO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-8" data-id="element-201">
          <table className="w-full text-left border-collapse" data-id="element-202">
            <thead data-id="element-203">
              <tr className="border-b border-slate-700" data-id="element-204">
                <th className="p-4 text-slate-300 font-medium" data-id="element-205">
                  Situación en tu cocina
                </th>
                <th className="p-4 text-slate-400 font-medium bg-slate-900/50" data-id="element-206">
                  ❌ Sin Freezer Pro
                </th>
                <th className="p-4 text-brand-400 font-bold bg-brand-900/10" data-id="element-207">
                  ✅ Con Freezer Pro
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800" data-id="element-208">
              <tr data-id="element-209">
                <td className="p-4 text-slate-300" data-id="element-210">
                  Tardás 3-4 horas cocinando el domingo
                </td>
                <td className="p-4 text-slate-400 bg-slate-900/50" data-id="element-211">
                  Seguís igual
                </td>
                <td className="p-4 text-white font-medium bg-brand-900/10" data-id="element-212">
                  Método de 4 Hornallas: 90 min = 30 porciones
                </td>
              </tr>
              <tr data-id="element-213">
                <td className="p-4 text-slate-300" data-id="element-214">
                  La carne está cada vez más cara
                </td>
                <td className="p-4 text-slate-400 bg-slate-900/50" data-id="element-215">
                  Pagás el precio del día
                </td>
                <td className="p-4 text-white font-medium bg-brand-900/10" data-id="element-216">
                  Biblia del Abasto: comprás un 40% más barato
                </td>
              </tr>
              <tr data-id="element-217">
                <td className="p-4 text-slate-300" data-id="element-218">
                  El freezer parece chico siempre
                </td>
                <td className="p-4 text-slate-400 bg-slate-900/50" data-id="element-219">
                  Comprás uno más grande
                </td>
                <td className="p-4 text-white font-medium bg-brand-900/10" data-id="element-220">
                  Flat & Stack: duplicás el espacio sin gastar nada
                </td>
              </tr>
              <tr data-id="element-221">
                <td className="p-4 text-slate-300" data-id="element-222">
                  La comida recalentada sabe a recalentada
                </td>
                <td className="p-4 text-slate-400 bg-slate-900/50" data-id="element-223">
                  Sin solución
                </td>
                <td className="p-4 text-white font-medium bg-brand-900/10" data-id="element-224">
                  Cubitos de Umami: sabe mejor que recién hecha
                </td>
              </tr>
              <tr data-id="element-225">
                <td className="p-4 text-slate-300" data-id="element-226">
                  No sabés cuándo comprar qué verdura
                </td>
                <td className="p-4 text-slate-400 bg-slate-900/50" data-id="element-227">
                  Pagás precio fuera de temporada
                </td>
                <td className="p-4 text-white font-medium bg-brand-900/10" data-id="element-228">
                  Calendario de 12 meses: ganarle a la inflación
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <Card className="bg-slate-900 border-brand-500/30 mb-10" data-id="element-229">
          <h3 className="text-xl font-bold text-white mb-5 flex items-center gap-2" data-id="element-230">
            <CheckCircle className="text-brand-400" data-id="element-231" /> EL MANUAL FREEZER PRO
            INCLUYE:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-232">
            {['El Método de las 4 Hornallas (90 min = 30 porciones)', 'La Biblia del Abasto Argentino (proteína un 40% más barata)', 'Ingeniería del Freezer Infinito (duplicar espacio sin comprar nada)', 'El Secreto del Umami (caldos, fondos y cubitos de sabor)', 'Calendario Estacional de 12 Meses (ganarle a la inflación)', 'Calculadora de ahorro anual personalizable', 'Plan de implementación de 90 días', 'Recetas Pro exclusivas'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-233">
                <CheckCircle className="w-5 h-5 text-brand-500 shrink-0 mt-0.5" data-id="element-234" />
                <span className="text-slate-300" data-id="element-235">{item}</span>
              </div>)}
          </div>
        </Card>

        <div className="text-center mb-10" data-id="element-236">
          <h3 className="text-2xl font-bold text-white flex items-center justify-center gap-2" data-id="element-237">
            <span className="text-red-500" data-id="element-238">❤️</span> MÁS FAMILIAS QUE YA LO
            TIENEN
          </h3>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-239">
          <Card data-id="element-240">
            <div className="flex gap-1 mb-2" data-id="element-241">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-242" />)}
            </div>
            <p className="text-slate-300 italic mb-4 text-sm" data-id="element-243">
              "El método de las 4 hornallas me cambió los domingos. Antes
              tardaba 4 horas y quedaba agotada. Ahora en 90 minutos tengo todo
              el freezer lleno y yo descansé la tarde entera."
            </p>
            <div data-id="element-244">
              <p className="font-bold text-white text-sm" data-id="element-245">Cecilia R.</p>
              <p className="text-xs text-slate-500" data-id="element-246">
                📍 Mendoza | Megapack + Freezer Pro
              </p>
            </div>
          </Card>

          <Card data-id="element-247">
            <div className="flex gap-1 mb-2" data-id="element-248">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-249" />)}
            </div>
            <p className="text-slate-300 italic mb-4 text-sm" data-id="element-250">
              "Con los cubitos de caldo del manual Pro, mi arroz blanco de los
              martes sabe a risotto de restaurante. No lo podía creer hasta que
              lo probé."
            </p>
            <div data-id="element-251">
              <p className="font-bold text-white text-sm" data-id="element-252">Roberto M.</p>
              <p className="text-xs text-slate-500" data-id="element-253">
                📍 Buenos Aires | Megapack Completo
              </p>
            </div>
          </Card>

          <Card data-id="element-254">
            <div className="flex gap-1 mb-2" data-id="element-255">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-256" />)}
            </div>
            <p className="text-slate-300 italic mb-4 text-sm" data-id="element-257">
              "Mis hijos terminaron pidiéndome los nuggets caseros del Tomo 4.
              Les conté que llevan calabaza y no me creyeron. Eso resume el
              sistema."
            </p>
            <div data-id="element-258">
              <p className="font-bold text-white text-sm" data-id="element-259">Sofía C.</p>
              <p className="text-xs text-slate-500" data-id="element-260">
                📍 La Plata | Megapack Completo
              </p>
            </div>
          </Card>

          <Card data-id="element-261">
            <div className="flex gap-1 mb-2" data-id="element-262">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-263" />)}
            </div>
            <p className="text-slate-300 italic mb-4 text-sm" data-id="element-264">
              "La Biblia del Abasto me enseñó a negociar con el carnicero.
              Ahorro más de $40.000 por mes solo en proteína. El sistema se pagó
              en la primera semana."
            </p>
            <div data-id="element-265">
              <p className="font-bold text-white text-sm" data-id="element-266">Pablo A.</p>
              <p className="text-xs text-slate-500" data-id="element-267">
                📍 Neuquén | Megapack + Freezer Pro
              </p>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}